import React from 'react';
import './uber2.css';
import VotePage from './vote-page';
import FinalistsPage from './finalists-page';

/**
 * @author Carl Trelfa
 */
const SHOW_FINALISTS_TIME = 1693782060 // Changover 2023: Mon Sep 04 2023 00:01:00 GMT+0100 (British Summer Time)
                            // 1657094400;     // test time, 04-07-2022, 16:55 = 1656950100
                                            // test time, 04-07-2022, 17:15 = 1656951300
                                            // test time, 05-07-2022, 9am = 1657008000
                                            // proper time, 06-07-2022, 9am = 1657094400

export default class ShowFinalistsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showFinalists: false,
            timeToShowFinalists: 0,
        }
    }

    componentDidMount() {      
        let time = Math.floor(Date.now() / 1000);

        let showFinalists = false;
        let timeToShowFinalists = 0;
        if (time > SHOW_FINALISTS_TIME) {
            showFinalists = true;
        } else {
            showFinalists = false;
            timeToShowFinalists = SHOW_FINALISTS_TIME - time;
        }

        if (!showFinalists) {
            setTimeout(this.updateCountdown, 1000);
        }
        
        // console.log('using uuid: ', uuid);
        this.setState({showFinalists: showFinalists, timeToShowFinalists: timeToShowFinalists});
    }

    updateCountdown = () => {
        let time = Math.floor(Date.now() / 1000);

        let showFinalists = this.state.showFinalists;
        let timeToShowFinalists = 0;
        if (time > SHOW_FINALISTS_TIME) {
            showFinalists = true;
        } else {
            showFinalists = false;
            timeToShowFinalists = SHOW_FINALISTS_TIME - time;
        }

        this.setState({showFinalists: showFinalists, timeToShowFinalists: timeToShowFinalists});
        if (!showFinalists) {
            setTimeout(this.updateCountdown, 1000);
        }
    }

    render() {
        return (
            <>
                {this.state.showFinalists === false &&
                    <VotePage></VotePage>
                }
                {this.state.showFinalists === true &&
                    <FinalistsPage></FinalistsPage>
                }
            </>
        );
    }

 }